import { Params } from '@angular/router';

import { Action } from '@ngrx/store';

import { TaskType } from '@common/entities/task/task-type.entity';

export enum FilterActionTypes {
    SetConceptsFilter = '[Filter] SetConceptsFilter',
    SetProcessingListFilter = '[Filter] SetProcessingListFilter',
    SetRejectedFilter = '[Filter] SetRejectedFilter',
    SetToDestroyFilter = '[Filter] SetToDestroyFilter',
    SetTaskFilter = '[Filter] SetTaskFilter',
    SetEvaluateFilter = '[Filter] SetEvaluateFilter',
    SetArchiveFilter = '[Filter] SetArchiveFilter'
}

export class SetConceptsFilter implements Action {
    type: FilterActionTypes.SetConceptsFilter = FilterActionTypes.SetConceptsFilter;
    constructor(public payload: Params) {}
}
export class SetProcessingListFilter implements Action {
    type: FilterActionTypes.SetProcessingListFilter = FilterActionTypes.SetProcessingListFilter;
    constructor(public payload: Params) {}
}
export class SetRejectedFilter implements Action {
    type: FilterActionTypes.SetRejectedFilter = FilterActionTypes.SetRejectedFilter;
    constructor(public payload: Params) {}
}

export class SetToDestroyFilter implements Action {
    type: FilterActionTypes.SetToDestroyFilter = FilterActionTypes.SetToDestroyFilter;
    constructor(public payload: Params) {}
}

export class SetTaskFilter implements Action {
    type: FilterActionTypes.SetTaskFilter = FilterActionTypes.SetTaskFilter;
    constructor(
        public payload: Params,
        public taskType: TaskType
    ) {}
}

export class SetEvaluateFilter implements Action {
    type: FilterActionTypes.SetEvaluateFilter = FilterActionTypes.SetEvaluateFilter;
    constructor(public payload: Params) {}
}

export class SetArchiveFilter implements Action {
    type: FilterActionTypes.SetArchiveFilter = FilterActionTypes.SetArchiveFilter;
    constructor(public payload: Params) {}
}

export type FilterAction =
    | SetConceptsFilter
    | SetProcessingListFilter
    | SetRejectedFilter
    | SetToDestroyFilter
    | SetTaskFilter
    | SetArchiveFilter
    | SetEvaluateFilter;
